import { Box, FormControlLabel, Radio, Switch } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { primary } from '@/theme/colors';

export const DeckPlanFormControl = muiStyled(FormControlLabel)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 15,
  marginTop: 15,
  marginLeft: 0,
}));

export const CustomizationPanel = muiStyled(Box)<{ navbarHeight: number }>(({ navbarHeight }) => ({
  padding: 16,
  overflowY: 'auto',
  overflowX: 'hidden',
  display: 'flex',
  alignItems: 'left',
  flexDirection: 'column',
  height: 'calc(100vh / var(--zoom) - 132px)',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  '@media (max-width: 1728px)': {
    height: `calc(100vh / var(--zoom) - ${navbarHeight + 65}px)`,
  },
}));

export const CustomSwitch = muiStyled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: theme.palette.common.darkBlue,
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: theme.palette.common.darkBlue,
  },
}));

export const CustomRadio = muiStyled(Radio)(({ theme }) => ({
  color: primary.main,
  '&.Mui-checked': {
    color: theme.palette.common.darkBlue,
  },
}));

export const EmptyHeatMapContainer = {
  width: '100%',
  my: 13,
};

export const EmptyHeatMapTypography = {
  opacity: '50%',
  lineHeight: '21px',
};

export const EmptyHeatMapIcon = {
  opacity: '50%',
  mb: '2%',
};

export const TooltipProps = {
  tooltip: {
    sx: {
      backgroundColor: 'rgb(0,0,0)',
      color: 'white',
      opacity: 1,
      fontSize: '1rem',
      display: 'flex',
      alignItems: 'center',
      paddingY: '10px',
      height: '28px',
      fontWeight: 500,
    },
  },
  arrow: {
    sx: { color: 'black' },
  },
};
